(function() {
  // Initialize each product-hotspots section
  function initializeSection(sectionElement) {
    const sectionId = sectionElement.dataset.sectionId;
    if (!sectionId) return;
    
    const section = document.getElementById(sectionId);
    if (!section) return;

    let swiperInstance = null;
    const hotspotClickHandlers = [];
    const panelClickHandlers = [];

    function selectHotspot(hotspotId) {
      if (!hotspotId) return;

      const allHotspots = section.querySelectorAll('product-hotspot-component');
      allHotspots.forEach((h) => h.classList.remove('hotspot--selected'));

      const targetHotspot = Array.from(allHotspots).find(
        (h) => h.dataset.referId === hotspotId
      );
      if (targetHotspot) {
        targetHotspot.classList.add('hotspot--selected');
      }

      const panels = section.querySelectorAll('.hotspots-panel__wrapper .hotspots-panel');
      panels.forEach((panel) => {
        const content = panel.querySelector('.hotspot-dialog__product-content');
        if (!content) return;

        const panelId = panel.dataset.referId;
        content.classList.toggle('hide', hotspotId !== panelId);
      });

      const productDetails = section.querySelectorAll('.hotspots-panel__mobile--detail');
      if (productDetails.length) {
        productDetails.forEach((detail) => {
          const detailId = detail.dataset.referId;
          detail.classList.toggle('hidden', hotspotId !== detailId);
        });
      }

      if (swiperInstance) {
        const slides = swiperInstance.slides;
        const targetSlideIndex = Array.from(slides).findIndex(
          (slide) => slide.dataset.referId === hotspotId
        );

        if (targetSlideIndex !== -1 && swiperInstance.activeIndex !== targetSlideIndex) {
          swiperInstance.slideTo(targetSlideIndex, 300);
        }
      }
    }

    function cleanup() {
      if (swiperInstance) {
        try {
          swiperInstance.destroy(true, true);
        } catch (e) {
          console.warn('Error destroying Swiper:', e);
        }
        swiperInstance = null;
      }

      hotspotClickHandlers.forEach(({ element, handler }) => {
        element.removeEventListener('click', handler);
      });
      hotspotClickHandlers.length = 0;

      panelClickHandlers.forEach(({ element, handler }) => {
        element.removeEventListener('click', handler);
      });
      panelClickHandlers.length = 0;

      const existingWrapper = section.querySelector('.hotspots-panel__wrapper');
      if (existingWrapper) {
        const container = section.querySelector('.hotspots-container');
        if (container) {
          const items = existingWrapper.querySelectorAll('.hotspots-panel');
          items.forEach(item => {
            container.appendChild(item);
          });
          existingWrapper.remove();
        }
      }

      const hotspotImage = section.querySelector('.hotspots-products');
      const hotspotDetail = section.querySelector('.hotspots-products__detail');

      if (hotspotImage) {
        hotspotImage.innerHTML = '';
      }
      if (hotspotDetail) {
        hotspotDetail.innerHTML = '';
      }

      const btnRight = section.querySelector('.swiper-button-next');
      const btnLeft = section.querySelector('.swiper-button-prev');
      if (btnRight && btnLeft) {
        const wrapper = section.querySelector('.section-product-hotspots__wrapper');
        if (wrapper) {
          if (btnRight.parentNode) {
            btnRight.parentNode.removeChild(btnRight);
          }
          if (btnLeft.parentNode) {
            btnLeft.parentNode.removeChild(btnLeft);
          }
          wrapper.appendChild(btnRight);
          wrapper.appendChild(btnLeft);
        }
      }
    }

    function initializeHotspots() {
      cleanup();

      const container = section.querySelector('.hotspots-container');
      if (!container) return;

      const items = container.querySelectorAll('.hotspots-panel');
      if (items.length > 0) {
        const wrapper = document.createElement('div');
        wrapper.className = 'hotspots-panel__wrapper';
        items[0].parentNode.insertBefore(wrapper, items[0]);
        items.forEach(item => wrapper.appendChild(item));
      }

      const images = container.querySelectorAll('.hotspots-panel__mobile--image');
      const details = container.querySelectorAll('.hotspots-panel__mobile--detail');

      if (images.length > 0 || details.length > 0) {
        const hotspotImage = section.querySelector('.hotspots-products');
        const hotspotDetail = section.querySelector('.hotspots-products__detail');
        const btnRight = section.querySelector('.swiper-button-next');
        const btnLeft = section.querySelector('.swiper-button-prev');

        if (hotspotImage && hotspotDetail && btnRight && btnLeft) {
          const imageWrap = document.createElement('div');
          const detailWrap = document.createElement('div');

          imageWrap.className = 'hotspots-mobile__image swiper-wrapper';
          if (images.length > 0) {
            images[0].parentNode.insertBefore(imageWrap, images[0]);
            images.forEach(image => imageWrap.appendChild(image));
          }

          detailWrap.className = 'hotspots-mobile__details';
          if (details.length > 0) {
            details[0].parentNode.insertBefore(detailWrap, details[0]);
            details.forEach(detail => detailWrap.appendChild(detail));
          }

          const swiper = document.createElement('div');
          swiper.className = 'swiper mobile-image';

          if (imageWrap.children.length > 0) {
            swiper.appendChild(imageWrap);
          }
          swiper.appendChild(btnRight);
          swiper.appendChild(btnLeft);
          hotspotImage.appendChild(swiper);
          hotspotDetail.appendChild(detailWrap);

          setTimeout(() => {
            const swiperEl = section.querySelector('.mobile-image');
            if (swiperEl && typeof Swiper !== 'undefined') {
              const slides = swiperEl.querySelectorAll('.swiper-slide');
              const slideCount = slides.length;
              const middleIndex = Math.floor(slideCount / 2);

              try {
                swiperInstance = new Swiper(swiperEl, {
                loop: false,
                centeredSlides: true,
                slidesPerView: 'auto',
                spaceBetween: 5,
                speed: 300,
                initialSlide: middleIndex,
                watchSlidesProgress: true,
                touchRatio: 1,
                threshold: 5,
                resistance: true,
                resistanceRatio: 0.85,
                allowTouchMove: true,
                grabCursor: true,
                navigation: {
                  nextEl: swiperEl.querySelector('.swiper-button-next'),
                  prevEl: swiperEl.querySelector('.swiper-button-prev'),
                },
                breakpoints: {
                  768: {
                    slidesPerView: 'auto',
                    spaceBetween: 10,
                  },
                },
                on: {
                  init: function() {
                    const activeSlide = this.slides[this.activeIndex];
                    if (activeSlide) {
                      const referId = activeSlide.dataset.referId;
                      if (referId) {
                        selectHotspot(referId);
                      }
                    }
                  },
                  slideChange: function() {
                    const activeSlide = this.slides[this.activeIndex];
                    if (activeSlide) {
                      const referId = activeSlide.dataset.referId;
                      if (referId) {
                        selectHotspot(referId);
                      }
                    }
                  },
                },
              });
              } catch (error) {
                console.error('Swiper initialization error:', error);
              }
            }
          }, 0);
        }
      }

      const hotspots = section.querySelectorAll('product-hotspot-component');
      hotspots.forEach((hotspot) => {
        const trigger = hotspot.querySelector('.hotspot-trigger');
        if (!trigger) return;

        const handler = () => {
          const hotspotId = hotspot.dataset.referId;
          selectHotspot(hotspotId);
        };

        trigger.addEventListener('click', handler);
        hotspotClickHandlers.push({ element: trigger, handler });
      });

      const desktopPanels = section.querySelectorAll('.hotspots-panel__wrapper .hotspots-panel');
      desktopPanels.forEach((panel) => {
        const link = panel.querySelector('.hotspot-dialog__link');
        if (!link) return;

        const panelHandler = (e) => {
          const panelId = panel.dataset.referId;
          if (!panelId) return;

          const content = panel.querySelector('.hotspot-dialog__product-content');
          if (!content) return;

          const isSelected = !content.classList.contains('hide');

          if (!isSelected) {
            e.preventDefault();
            e.stopPropagation();
            selectHotspot(panelId);
          }
        };

        link.addEventListener('click', panelHandler);
        panelClickHandlers.push({ element: link, handler: panelHandler });
      });

      const mobileImagePanels = section.querySelectorAll('.hotspots-panel__mobile--image');
      mobileImagePanels.forEach((panel) => {
        const link = panel.querySelector('.hotspot-dialog__link');
        if (!link) return;

        const panelHandler = (e) => {
          const panelId = panel.dataset.referId;
          if (!panelId) return;

          const detailPanel = section.querySelector(
            `.hotspots-panel__mobile--detail[data-refer-id="${panelId}"]`
          );
          if (!detailPanel) return;

          const isSelected = !detailPanel.classList.contains('hidden');

          if (!isSelected) {
            e.preventDefault();
            e.stopPropagation();
            selectHotspot(panelId);
          }
        };

        link.addEventListener('click', panelHandler);
        panelClickHandlers.push({ element: link, handler: panelHandler });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeHotspots);
    } else {
      initializeHotspots();
    }

    document.addEventListener('shopify:section:load', function(event) {
      if (event.target && event.target.id === sectionId) {
        setTimeout(initializeHotspots, 50);
      }
    });
  }

  // Initialize all sections on page load
  function initAllSections() {
    const sections = document.querySelectorAll('[data-section-id]');
    sections.forEach(initializeSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllSections);
  } else {
    initAllSections();
  }

  // Handle dynamically loaded sections
  document.addEventListener('shopify:section:load', function(event) {
    if (event.target && event.target.dataset.sectionId) {
      setTimeout(() => initializeSection(event.target), 50);
    }
  });
})();
